import React from "react";
import ImageOrFlag from "../Common/MatchSideImageOrFlag.jsx";
import SideDetailsHeadToHead from "./SideDetailsHeadToHead.jsx";
import SideDetailsTeam from "./SideDetailsTeam.jsx";

const Details = ({matchDetails, match, achievements, isHeadToHeadAchievements, onClose}) => {
    let header, sideA, sideB;

    header = <div className="game-details-header">
        <ImageOrFlag side={matchDetails.sideA.side}/>{`${matchDetails.sideA.side.name}`}
        <strong className="result-points">{match.formattedResult}</strong>
        <ImageOrFlag side={matchDetails.sideB.side}/>{`${matchDetails.sideB.side.name}`}
        <div>{match.formattedPartsResults}</div>
    </div>;
    if (isHeadToHeadAchievements) {
        sideA = <SideDetailsHeadToHead achievements={achievements} {...matchDetails.sideA}/>;
        sideB = <SideDetailsHeadToHead achievements={achievements} {...matchDetails.sideB}/>;
    } else {
        sideA = <SideDetailsTeam achievements={achievements} {...matchDetails.sideA}/>;
        sideB = <SideDetailsTeam achievements={achievements} {...matchDetails.sideB}/>;
    }

    return <div id="matchModal" className="modal game-details-modal" role="dialog" style={{display: 'block'}}>
        <div className="modal-dialog results-match-modal">
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title text-center">
                        {header}
                    </h4>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-xs-6">
                            {sideA}
                        </div>
                        <div className="col-xs-6">
                            {sideB}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button onClick={onClose} type="button" className="btn-orange btn-flex-bs btn-modal-ok">OK</button>
                </div>
            </div>
        </div>
    </div>;
};

export default Details;